import React, { useState } from 'react';
import { X, Copy, CheckCircle2 } from 'lucide-react';
import { personnelApi } from '../../services/api';
import { useToast } from '../../components/ui/use-toast';
import { Button } from '../../components/ui/button';
import { Label } from '../../components/ui/label';
import { rolesForDepartment, roleTr } from '../../lib/roles';

const CreateUserForPersonnelModal = ({ personnel, onClose, onSuccess }) => {
  const { toast } = useToast();
  const [department, setDepartment] = useState(personnel.department || 'saha');
  const [role, setRole] = useState('');
  const [loading, setLoading] = useState(false);
  const [credentials, setCredentials] = useState(null);

  const roles = rolesForDepartment(department);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!role) {
      toast({ title: 'Hata', description: 'Rol seçin', variant: 'destructive' });
      return;
    }
    setLoading(true);
    try {
      const res = await personnelApi.createUser(personnel.id, { role, department });
      setCredentials(res.data?.data?.credentials);
      toast({ title: 'Başarılı', description: 'Kullanıcı oluşturuldu', variant: 'success' });
      onSuccess?.();
    } catch (err) {
      toast({ title: 'Hata', description: err.response?.data?.message || 'Oluşturulamadı', variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  };

  const copy = (txt) => navigator.clipboard?.writeText(txt);

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
          <h2 className="text-lg font-bold text-slate-900">Kullanıcı Oluştur</h2>
          <button onClick={onClose} className="rounded-lg p-1.5 text-slate-400 hover:bg-slate-100">
            <X className="h-5 w-5" />
          </button>
        </div>

        {credentials ? (
          <div className="p-6 space-y-4">
            <div className="flex items-center gap-2 text-emerald-600">
              <CheckCircle2 className="h-5 w-5" />
              <p className="font-semibold">Hesap oluşturuldu</p>
            </div>
            <p className="text-sm text-slate-500">
              Bu bilgileri personele iletin. Kullanıcı ilk girişte şifresini değiştirmek zorundadır.
            </p>
            {[
              { label: 'E-posta', value: credentials.email },
              { label: 'Geçici Şifre', value: credentials.password },
            ].map((f) => (
              <div key={f.label} className="rounded-lg bg-slate-50 px-3 py-2 flex items-center justify-between">
                <div className="min-w-0">
                  <p className="text-[11px] uppercase tracking-wide text-slate-400">{f.label}</p>
                  <p className="text-sm font-mono text-slate-800 truncate">{f.value}</p>
                </div>
                <button onClick={() => copy(f.value)} className="text-slate-400 hover:text-blue-600 shrink-0">
                  <Copy className="h-4 w-4" />
                </button>
              </div>
            ))}
            <Button onClick={onClose} className="w-full bg-blue-600 hover:bg-blue-700">Kapat</Button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="p-6 space-y-4">
            <p className="text-sm text-slate-500">
              <span className="font-medium text-slate-700">{personnel.first_name} {personnel.last_name}</span> için
              giriş hesabı oluşturulacak. E-posta otomatik üretilir
              (<span className="font-mono">adsoyad@emtambulans.com</span>).
            </p>

            <div className="space-y-1.5">
              <Label className="text-sm font-medium text-slate-700">Departman</Label>
              <select
                value={department}
                onChange={(e) => { setDepartment(e.target.value); setRole(''); }}
                className="w-full h-10 border border-slate-200 rounded-lg px-3 text-sm bg-white focus:ring-2 focus:ring-blue-500"
              >
                <option value="saha">Saha</option>
                <option value="idari">İdari</option>
              </select>
            </div>

            <div className="space-y-1.5">
              <Label className="text-sm font-medium text-slate-700">Rol</Label>
              <select
                value={role}
                onChange={(e) => setRole(e.target.value)}
                className="w-full h-10 border border-slate-200 rounded-lg px-3 text-sm bg-white focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Rol seçin</option>
                {roles.map((r) => (
                  <option key={r} value={r}>{roleTr(r)}</option>
                ))}
              </select>
            </div>

            <div className="flex justify-end gap-2 pt-2 border-t border-slate-100">
              <Button type="button" variant="outline" onClick={onClose}>İptal</Button>
              <Button type="submit" disabled={loading} className="bg-blue-600 hover:bg-blue-700">
                {loading ? 'Oluşturuluyor...' : 'Kullanıcı Oluştur'}
              </Button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default CreateUserForPersonnelModal;
